import React from 'react';

function CodeIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141B34'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M16 10l1.227 1.057c.515.445.773.667.773.943 0 .276-.258.498-.773.943L16 14M8 10l-1.227 1.057C6.258 11.502 6 11.724 6 12c0 .276.258.498.773.943L8 14M13 9l-2 6'
			></path>
			<path
				stroke='#141B34'
				strokeWidth='1.5'
				d='M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109C18.717 21.5 16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391C2.5 18.717 2.5 16.479 2.5 12z'
			></path>
		</svg>
	);
}

export default CodeIcon;
